import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CopModuleState, copModuleKey } from '../cop/cop.reducer';
import * as fromRsd from './rsd.reducer';

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectRsdState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.rsd);

export const selectSelectedDocumentState = createSelector(selectRsdState, fromRsd.getSelectedDocumentState);

export const selectIsDrawerOpen = createSelector(selectRsdState, fromRsd.getIsDrawerOpen);

export const selectIsEdit = createSelector(selectRsdState, fromRsd.getIsEdit);

export const selectIsNew = createSelector(selectRsdState, fromRsd.getIsNew);

export const selectSelectedDocumentStackCount = createSelector(selectRsdState, fromRsd.getSelectedDocumentStackCount);
export const selectSelectedDocumentStack = createSelector(selectRsdState, fromRsd.getSelectedDocumentStack);

// related docs
export const selectRelatedDatasets = createSelector(selectRsdState, fromRsd.getRelatedDatasets);
//export const selectRelatedDocuments = createSelector(selectRsdState, fromRsd.getRelatedDocuments);
export const selectNewRelatedDocument = createSelector(selectRsdState, fromRsd.getNewRelatedDocument);
export const selectRelatedDocumentCountsByDataset = createSelector(selectRsdState, fromRsd.getRelatedDocumentCountsByDataset);
